import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { StartClient } from "@tanstack/react-start/client";
import { installFeedbackConsoleCapture } from "@softmax/web-features/feedback/capture";
import {
  deferredAnalytics,
  startAnalytics,
} from "@softmax/web-features/telemetry/analytics";
import { connectAnalytics } from "@softmax/ide/analytics";
import {
  configureDatadogRum,
  initializeDatadogRum,
} from "@softmax/web-features/telemetry/rum";
import { publicConfig } from "./lib/public-config";
import { telemetryUrl } from "@softmax/web-features/telemetry/urls";

connectAnalytics(deferredAnalytics);

installFeedbackConsoleCapture();

configureDatadogRum(publicConfig.datadogRum);

const startDeferredAnalytics = () => {
  void startAnalytics();
  void initializeDatadogRum();
  const config = publicConfig.datadogRum;

  if (config)
    void import("@datadog/browser-logs").then(({ datadogLogs }) => {
      datadogLogs.init({
        clientToken: config.clientToken,
        site: config.site,
        service: config.service,
        env: config.environment,
        version: config.version,
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        beforeSend(event) {
          if (event.view?.url) {
            event.view.url = telemetryUrl(event.view.url);
          }

          if (event.view?.referrer) {
            event.view.referrer = telemetryUrl(event.view.referrer);
          }

          return true;
        },
      });
    });
};

if (typeof requestIdleCallback === "function")
  requestIdleCallback(startDeferredAnalytics, { timeout: 2000 });
else window.setTimeout(startDeferredAnalytics, 2000);

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <StartClient />
    </StrictMode>,
  );
});
